import { render, staticRenderFns } from "./PageAccessDenied.vue?vue&type=template&id=0cc03d42&scoped=true&"
import script from "./PageAccessDenied.vue?vue&type=script&lang=ts&"
export * from "./PageAccessDenied.vue?vue&type=script&lang=ts&"
import style0 from "./PageAccessDenied.vue?vue&type=style&index=0&id=0cc03d42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc03d42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
